module.exports = __webpack_public_path__ + "frontend/images/homepage/visual/visual.jpg?c7946c45fc7932a8bd3c009a1a443229";